function Profile() {
  return <div>Profile Seller</div>;
}

export default Profile;
